import { ReactNode } from 'react'
import { connect } from 'react-redux'

import moment from 'moment'

import BasePage, { CONNECTION_ERROR } from '../BasePage'

import { 
    AccidentListType, AccidentType, 
    AccidentErrorType, AccidentErrorList
} from '../../components/insurance/StatusSlice'

import Contractor, { ContractorType } from '../../components/people/contractor/Contractor'
import { FisicaType  } from '../../components/people/PeopleSlice'
import { getGenericPeopleForSubmit, getGenericPeopleError } from '../../components/people/other/GenericPeople'

import VehicleManualTyping from '../../components/vehicle/VehicleManualTyping'

import LoginRegister from '../../components/login/LoginRegister'
import StatoAssicurativo from '../../components/insurance/StatoAssicurativo'
import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import { authFetch } from '../../libs/cookie/Cookie'

import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import { STEP_2_VALIDATION_URL, STEP_3_VALIDATION_URL } from '../../costants'

import { isValidPrivacy, getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'
import { isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'
import { CompleteValidationError } from '../../libs/validation/completeValidationError'
import { 
    PATTERN_TARGA_50CC, isValidTarga, isValid, isEmpty 
} from '../../libs/validation/stringRegex'

import { microInitialState, microcarUpdate, MicroCarProps, MicroCarPageState } from './MicroCarSilce'

import { MICROCAR_MIN_CONDUCENTE_AGE } from '../../components/insurance/StatusSlice'

import { 
    getTipoMicroCar, getTipoAlimentazione, getTipoMarce, getFruizioneEredita, getTipoCuEreditata, getTipoVeicoloEreditaCu,
    getTipoCuAttuale, getTipoAnzianitaPrimaClasse, getCompagnieAttuali, getEtaAssicurativa,
    getAnniIncidenti, getResponsabilitaIncidenti, getTipoStatoAssicurativo, getTipiRelazionePersone,
    BaseEnumType
} from '../../libs/initialization/remoteInits'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'


class MicroCarPage extends BasePage<MicroCarProps, MicroCarPageState> {
    constructor (props: any) {
        super(props)

        this.state = {
            ...microInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)
        this.updateContractor = this.updateContractor.bind(this)

        // enums
        this.updateTipiVeicolo = this.updateTipiVeicolo.bind(this)
        this.updateTipiAlimentazione = this.updateTipiAlimentazione.bind(this)
        this.updateTipiMarce = this.updateTipiMarce.bind(this)
        this.updateTipiStatoAssicurativo = this.updateTipiStatoAssicurativo.bind(this)
        this.updateTipiFruizioneEredita = this.updateTipiFruizioneEredita.bind(this)
        this.updateTipiCuEreditata = this.updateTipiCuEreditata.bind(this)
        this.updateTipiCuAttuale = this.updateTipiCuAttuale.bind(this)
        this.updateTipiAnzianitaPrimaClasse = this.updateTipiAnzianitaPrimaClasse.bind(this)
        this.updateTipiCompagnieAttuali = this.updateTipiCompagnieAttuali.bind(this)
        this.updateTipiEtaAssicurativa = this.updateTipiEtaAssicurativa.bind(this)
        this.updateTipiAnniIncidenti = this.updateTipiAnniIncidenti.bind(this)
        this.updateTipiResponsabilitaIncidenti = this.updateTipiResponsabilitaIncidenti.bind(this)
        this.updateTipiVeicoloEretiaCu = this.updateTipiVeicoloEretiaCu.bind(this)
        this.updateTipiRelazioniPersone = this.updateTipiRelazioniPersone.bind(this)

        // metodi specifici del preventivatore
        this.updateTipoVeicolo = this.updateTipoVeicolo.bind(this)
        this.updateAnnoImmatricolazione = this.updateAnnoImmatricolazione.bind(this)
        this.updateAnnoAcquisto = this.updateAnnoAcquisto.bind(this)
        this.updateMeseImmatricolazione = this.updateMeseImmatricolazione.bind(this)
        this.updateTarga = this.updateTarga.bind(this)
        this.updateMarca = this.updateMarca.bind(this)
        this.updateModello = this.updateModello.bind(this)
        this.updateAlimentazione = this.updateAlimentazione.bind(this)
        this.updateAllestimento = this.updateAllestimento.bind(this)
        this.updateKw = this.updateKw.bind(this)
        this.updateMarce = this.updateMarce.bind(this)

        this.updateStatoAssicurativo = this.updateStatoAssicurativo.bind(this)
        this.updateTipoVeicoloEreditaCu = this.updateTipoVeicoloEreditaCu.bind(this)
        this.updateTipoEreditaCu = this.updateTipoEreditaCu.bind(this)
        this.updateTargaCu = this.updateTargaCu.bind(this)
        this.updateCuEreditata = this.updateCuEreditata.bind(this)
        this.updateCuAttuale = this.updateCuAttuale.bind(this)
        this.updateAnzianitaPrimaClasse = this.updateAnzianitaPrimaClasse.bind(this)
        this.updateCompagniaAttuale = this.updateCompagniaAttuale.bind(this)
        this.updateEtaAssicurativa = this.updateEtaAssicurativa.bind(this)
        this.updateHaEreditatoCu = this.updateHaEreditatoCu.bind(this)
        this.updateNumeroIncidenti = this.updateNumeroIncidenti.bind(this)
        this.updateIncidenti = this.updateIncidenti.bind(this)
        this.updateIsSameContractorOwner = this.updateIsSameContractorOwner.bind(this)
        this.updateOwner = this.updateOwner.bind(this)
        this.updateAltriConducenti = this.updateAltriConducenti.bind(this)
        this.updateEtaConducentePiuGiovane = this.updateEtaConducentePiuGiovane.bind(this)

        this.isValidAnnoImmatricolazione = this.isValidAnnoImmatricolazione.bind(this)
        this.isValidAnnoAcquisto = this.isValidAnnoAcquisto.bind(this)
        this.isValidMeseAcquisto = this.isValidMeseAcquisto.bind(this)

        this.getStep2ForValidation = this.getStep2ForValidation.bind(this)
        this.step2Validation = this.step2Validation.bind(this)

        this.getStep3ForValidation = this.getStep3ForValidation.bind(this)
        this.step3Validation = this.step3Validation.bind(this)

        this.isValidTargaVeicolo = this.isValidTargaVeicolo.bind(this)
        this.isNotSameOC = this.isNotSameOC.bind(this)
    }

    componentDidMount(): void {
        super.componentDidMount()

        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.tipiVeicolo === undefined) {
            getTipoMicroCar(this.updateTipiVeicolo, this.manageExpiredSessions)
        }
        if (this.state.tipiAlimentazione === undefined) {
            getTipoAlimentazione(this.updateTipiAlimentazione, this.manageExpiredSessions)
        }
        if (this.state.tipiMarce === undefined) {
            getTipoMarce(this.updateTipiMarce, this.manageExpiredSessions)
        }

        if (this.state.tipiStatoAssicurativo === undefined) {
            getTipoStatoAssicurativo (this.updateTipiStatoAssicurativo, this.manageExpiredSessions)
        }
        if (this.state.tipiFruizioneEredita === undefined) {
            getFruizioneEredita (this.updateTipiFruizioneEredita, this.manageExpiredSessions)
        }
        if (this.state.tipiCuEreditata === undefined) {
            getTipoCuEreditata (this.updateTipiCuEreditata, this.manageExpiredSessions)
        }
        if (this.state.tipiCuAttuale === undefined) {
            getTipoCuAttuale (this.updateTipiCuAttuale, this.manageExpiredSessions)
        }
        if (this.state.tipiAnzianitaPrimaClasse === undefined) {
            getTipoAnzianitaPrimaClasse (this.updateTipiAnzianitaPrimaClasse, this.manageExpiredSessions)
        }
        if (this.state.tipiCompagnieAttuali === undefined) {
            getCompagnieAttuali (this.updateTipiCompagnieAttuali, this.manageExpiredSessions)
        }
        if (this.state.tipiEtaAssicurativa === undefined) {
            getEtaAssicurativa (this.updateTipiEtaAssicurativa, this.manageExpiredSessions)
        }
        if (this.state.tipiAnniIncidenti === undefined) {
            getAnniIncidenti (this.updateTipiAnniIncidenti, this.manageExpiredSessions)
        }
        if (this.state.tipiResponsabilitaIncidenti === undefined) {
            getResponsabilitaIncidenti (this.updateTipiResponsabilitaIncidenti, this.manageExpiredSessions)
        }
        if (this.state.tipiVeicoloEretiaCu === undefined) {
            getTipoVeicoloEreditaCu (this.updateTipiVeicoloEretiaCu, this.manageExpiredSessions)
        }
        if (this.state.tipiRelazioniPersone === undefined) {
            getTipiRelazionePersone (this.updateTipiRelazioniPersone, this.manageExpiredSessions)
        }
    }

    render(): ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="microcar_form">
                                <Pagination
                                    maxPagges={3}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={true}
                                            isOnlyGiuridica={false}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={false}
                                        validatePage={this.step2Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <div className='col-12'>
                                            
                                            <VehicleManualTyping
                                                tipoVeicolo={this.state.tipoVeicolo}
                                                targa={this.state.targa}
                                                annoImmatricolazione={this.state.annoImmatricolazione}
                                                annoAcquisto={this.state.annoAcquisto}
                                                meseImmatricolazione={this.state.meseImmatricolazione}
                                                marca={this.state.marca}
                                                modello={this.state.modello}
                                                alimentazione={this.state.alimentazione}
                                                allestimento={this.state.allestimento}
                                                kw={this.state.kw}
                                                marce={this.state.marce}

                                                tipoVeicoloError={this.state.tipoVeicoloError}
                                                targaError={this.state.targaError}
                                                annoImmatricolazioneError={this.state.annoImmatricolazioneError}
                                                annoAcquistoError={this.state.annoAcquistoError}
                                                meseImmatricolazioneError={this.state.meseImmatricolazioneError}
                                                marcaError={this.state.marcaError}
                                                modelloError={this.state.modelloError}
                                                alimentazioneError={this.state.alimentazioneError}
                                                allestimentoError={this.state.allestimentoError}
                                                kwError={this.state.kwError}
                                                marceError={this.state.marceError}

                                                updateTipoVeicoloCallBack={this.updateTipoVeicolo}
                                                updateTargaCallBack={this.updateTarga}
                                                updateAnnoImmatricolazioneCallBack={this.updateAnnoImmatricolazione}
                                                updateAnnoAcquistoCallBack={this.updateAnnoAcquisto}
                                                updateMeseImmatricolazioneCallBack={this.updateMeseImmatricolazione}
                                                updateMarcaCallBack={this.updateMarca}
                                                updateModelloCallBack={this.updateModello}
                                                updateAlimentazioneCallBack={this.updateAlimentazione}
                                                updateAllestimentoCallBack={this.updateAllestimento}
                                                updateKwCallBack={this.updateKw}
                                                updateMarceCallBack={this.updateMarce}

                                                regexAnnoImmatricolazione={this.isValidAnnoImmatricolazione}
                                                regexAnnoAcquisto={this.isValidAnnoAcquisto}
                                                regexMeseAcquisto={this.isValidMeseAcquisto}

                                                tipiVeicolo={this.state.tipiVeicolo}
                                                tipiAlimentazione={this.state.tipiAlimentazione}
                                                tipiMarce={this.state.tipiMarce}
                                            />

                                        </div>
                                        
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 3}
                                        pageNumber={3}
                                        isLast={true}
                                        validatePage={this.step3Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <div className='col-12'>

                                            <StatoAssicurativo 
                                                statoAssicurativo={this.state.statoAssicurativo}
                                                tipoEreditaCu={this.state.tipoEreditaCu}
                                                tipoVeicoloEreditaCu={this.state.tipoVeicoloEreditaCu}
                                                targaCu={this.state.targaCu}
                                                cuEreditata={this.state.cuEreditata}
                                                cuAttuale={this.state.cuAttuale}
                                                anzianitaPrimaClasse={this.state.anzianitaPrimaClasse}
                                                compagniaAttuale={this.state.compagniaAttuale}
                                                etaAssicurativa={this.state.etaAssicurativa}
                                                numeroIncidenti={this.state.numeroIncidenti}
                                                incidenti={this.state.incidenti}
                                                haEreditatoCu={this.state.haEreditatoCu}
                                                dataScadenza={this.state.scadenzaPolizza}

                                                showOwner={this.state.contractor !== undefined && this.state.contractor.tipoPersona === 'fisica'}
                                                isSameContractorOwner={this.state.isSameContractorOwner}
                                                owner={this.state.owner}

                                                altriConducenti={this.state.altriConducenti}
                                                etaConducentePiuGiovane={this.state.etaConducentePiuGiovane}
                                                etaMinimaConducente={MICROCAR_MIN_CONDUCENTE_AGE}

                                                statoAssicurativoError={this.state.statoAssicurativoError}
                                                tipoEreditaCuError={this.state.tipoEreditaCuError}
                                                tipoVeicoloEreditaCuError={this.state.tipoVeicoloEreditaCuError}
                                                targaCuError={this.state.targaCuError}
                                                cuEreditataError={this.state.cuEreditataError}
                                                cuAttualeError={this.state.cuAttualeError}
                                                anzianitaPrimaClasseError={this.state.anzianitaPrimaClasseError}
                                                compagniaAttualeError={this.state.compagniaAttualeError}
                                                etaAssicurativaError={this.state.etaAssicurativaError}
                                                haEreditatoCuError={this.state.haEreditatoCuError}
                                                numeroIncidentiError={this.state.numeroIncidentiError}
                                                incidentiError={this.state.incidentiError}
                                                dataScadenzaError={this.state.scadenzaPolizzaError}

                                                isSameContractorOwnerError={this.state.isSameContractorOwnerError}
                                                ownerError={this.state.ownerError}
                                                contractor={this.state.contractor}
                                                altriConducentiError={this.state.altriConducentiError}
                                                etaConducentePiuGiovaneError={this.state.etaConducentePiuGiovaneError}

                                                tipiStatoAssicurativo={this.state.tipiStatoAssicurativo}
                                                tipiFruizioneEredita={this.state.tipiFruizioneEredita}
                                                tipiCuEreditata={this.state.tipiCuEreditata}
                                                tipiCuAttuale={this.state.tipiCuAttuale}
                                                tipiAnzianitaPrimaClasse={this.state.tipiAnzianitaPrimaClasse}
                                                tipiCompagnieAttuali={this.state.tipiCompagnieAttuali}
                                                tipiEtaAssicurativa={this.state.tipiEtaAssicurativa}
                                                tipiAnniIncidenti={this.state.tipiAnniIncidenti}
                                                tipiResponsabilitaIncidenti={this.state.tipiResponsabilitaIncidenti}
                                                tipiVeicoloEretiaCu={this.state.tipiVeicoloEretiaCu}
                                                tipiRelazioniPersone={this.state.tipiRelazioniPersone}

                                                updateStatoAssicurativoCallBack={this.updateStatoAssicurativo}
                                                updateDataScadenza={this.updateScadenzaPolizza}
                                                updateTipoEreditaCuCallBack={this.updateTipoEreditaCu}
                                                updateTipoVeicoloEreditaCuCallBack={this.updateTipoVeicoloEreditaCu}
                                                updateTargaCuCallBack={this.updateTargaCu}
                                                updateCuEreditataCallBack={this.updateCuEreditata}
                                                updateCuAttualeCallBack={this.updateCuAttuale}
                                                updateAnzianitaPrimaClasseCallBack={this.updateAnzianitaPrimaClasse}
                                                updateCompagniaAttualeIdCallBack={this.updateCompagniaAttuale}
                                                updateEtaAssicurativaCallBack={this.updateEtaAssicurativa}
                                                updateHaEreditatoCuCallBack={this.updateHaEreditatoCu}
                                                updateNumeroIncidentiCallBack={this.updateNumeroIncidenti}
                                                updateIncidentiCallBack={this.updateIncidenti}

                                                updateIsSameContractorOwnerCallBack={this.updateIsSameContractorOwner}
                                                updateOwnerCallBack={this.updateOwner}
                                                updateUserCallBack={this.updateUser}

                                                updateAltriConducentiCallBack={this.updateAltriConducenti}
                                                updateEtaConducentePiuGiovaneCallBack={this.updateEtaConducentePiuGiovane}

                                                user={this.state.user}
                                                manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                            />

                                        </div>

                                        <NoMotorPrivacy 
                                            id='noMotorPrivacy'
                                            basePrivacy={this.state.noMotorPrivacy}
                                            isLogged={this.state.user !== undefined}
                                            callback={this.updateNoMotorPrivacy}
                                            error={this.state.noMotorPrivacyError}
                                        />
                                    </SinglePage>

                                </Pagination>
                            </form>

                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }

    // -- comuni
    getInitialState() {
        return microInitialState
    }

    getValidationError () : Promise<CompleteValidationError> {
        return Promise.all([
            this.step1Validation(),
            this.step2Validation(),
            this.step3Validation()
        ])
        .then ((responses) => {
            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }
            else if (responses[2] !== undefined) {
                p = 3
                e = responses[2]
            }

            return {
                errorString: e,
                pageError: p
            }
        })
        .catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }

    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        } 
        else {
            let tipoVeicoloErro = undefined
            let targaErro = undefined

            let immatricolazioneErro = undefined
            let annoAcquistoErro = undefined
            let meseImmatricolazioneErro = undefined

            let marcaErro = undefined
            let modelloErro = undefined
            let alimentazioneErro = undefined
            let allestimentoErro = undefined
            let kwErro = undefined
            let marceErro = undefined

            let statoAssicurativoErro = undefined
            let tipoEreditaCuErro = undefined
            let cuEreditataErro = undefined
            let tipoVeicoloEreditaCuErro = undefined
            let targaCuErro = undefined

            let cuAttualeErro = undefined
            let anzianitaPrimaClasseErro = undefined
            let compagniaAttualeErro = undefined
            let etaAssicurativaErro = undefined
            let numeroIncidentiErro = undefined
            let haEreditatoCuErro = undefined

            let incidentiErro : AccidentErrorType[] = []

            let isSameContractorOwnerErro = undefined
            let ownerErro = undefined

            let altriConducentiErro = undefined
            let etaConducentePiuGiovaneErro = undefined

            let noMotorPrivacyErro = undefined
            
            let global = undefined

            const isLogged = this.state.user !== undefined

            if (errorString === 'TIPOVEICOLO') {
                tipoVeicoloErro = 'Selezionare la tipologia del veicolo'
                global = tipoVeicoloErro
            }
            else if (errorString === 'TARGA') {
                targaErro = 'Valore non valido'
                global = 'Inserire una targa valida'
            }

            else if (errorString === "ANNO_IMMATRICOLAZIONE") {
                immatricolazioneErro = "Valore non valido"
                global = "Selezionare un anno di immatricolazione valido"
            }
            else if (errorString === "ANNO_ACQUISTO") {
                annoAcquistoErro = "Valore non valido"
                global = "Selezionare un anno d'acquisto valido"
            }
            else if (errorString === "MESE_IMMATRICOLAZIONE") {
                meseImmatricolazioneErro = "Valore non valido"
                global = "Selezionare un mese d'acquisto valido"
            }

            else if (errorString === 'MARCA') {
                marcaErro = 'Valore non valido'
                global = 'Indicare la marca del veicolo'
            }
            else if (errorString === 'MODELLO') {
                modelloErro = 'Valore non valido'
                global = 'Indicare il modello del veicolo'
            }
            else if (errorString === 'ALIMENTAZIONE') {
                alimentazioneErro = 'Valore non valido'
                global = "Indicare l'alimentazione' del veicolo"
            }
            else if (errorString === 'ALLESTIMENTO') {
                allestimentoErro = 'Valore non valido'
                global = "Indicare l'allestimento' del veicolo"
            }
            else if (errorString === 'KW') {
                kwErro = 'Valore non valido'
                global = 'Indicare i kilowatt del veicolo'
            }
            else if (errorString === 'MARCE') {
                marceErro = 'Valore non valido'
                global = 'Specificare se il veicolo ha le marce'
            }

            else if (errorString === 'STATO_ASSICURATIVO') {
                statoAssicurativoErro = 'Valore non valido'
                global = 'Specificare se il veicolo è già assicurato'
            }
            else if (errorString === 'TIPO_EREDITA_CU') {
                tipoEreditaCuErro = 'Valore non valido'
                global = 'Indicare se si vuole utilizzare la classe di merito di un altro veicolo'
            }
            else if (errorString === 'CU_EREDITATA') {
                cuEreditataErro = 'Valore non valido'
                global = "Indicare la classe di merito dell'altro veicolo"
            }
            else if (errorString === "TIPO_VEICOLO_ERETIA") {
                tipoVeicoloEreditaCuErro = 'Valore non valido'
                global = 'Indicare la tipologia di veicolo da cui si eredita la classe di merito'
            }
            else if (errorString === 'TARGA_CU') {
                targaCuErro = 'Valore non valido'
                global = "Indicare la targa dell'altro veicolo"
            }

            else if (errorString === 'CU_ATTUALE') {
                cuAttualeErro = 'Valore non valido'
                global = 'Indicare la classe di merito di assegnazione'
            }
            else if (errorString === 'ANZIANITA_PRIMA_CLASSE') {
                anzianitaPrimaClasseErro = 'Valore non valido'
                global = 'Indicare il numero di anni da cui ci si trova in prima classe'
            }
            else if (errorString === 'COMPAGNIA_ATTUALE') {
                compagniaAttualeErro = 'Valore non valido'
                global = 'Indicare con quale compagnia si è assicurati'
            }
            else if (errorString === 'ETA_ASSICURATIVA') {
                etaAssicurativaErro = 'Valore non valido'
                global = 'Indicare da quanti anni si è assicurati'
            }
            else if (errorString === 'NUMERO_INCIDENTI') {
                numeroIncidentiErro = 'Valore non valido'
                global = 'Indicare il numero di incidenti'
            }
            else if (errorString === 'DETTAGLIO_INCIDENTI') {
                for (let i = 0; i < (this.state.numeroIncidenti ?? 0); i++) {
                    const accIndex = this.state.incidenti.findIndex( (acc: AccidentType) => acc.numero === i )

                    if (
                        accIndex < 0 || 
                        isEmpty(this.state.incidenti[accIndex].anno) ||
                        isEmpty(this.state.incidenti[accIndex].responsabilita)
                    ) {
                        incidentiErro.push ({
                            numero: i,
                            error: "Valore non valido"
                        })
                    }
                }
                global = 'Completare il paragrafo sugli incidenti'
            }
            else if (errorString === 'HA_EREDITATO_CU') {
                haEreditatoCuErro = 'Valore non valido'
                global = 'Indicare se la classe di merito è stata ereditata'
            }

            else if (errorString === 'CONTRAENTE_PROPRIETARIO') {
                isSameContractorOwnerErro = 'Valore non valido'
                global = 'Specificare il tipo di relazione tra Proprietario del veicolo e Contraente della polizza'
            }
            else if (errorString === 'PROPRIETARIO') {
                const specificError = (this.state.owner === undefined)
                    ? 'PEOPLE_'
                    : getGenericPeopleError(this.state.owner, 'PEOPLE', isLogged)

                ownerErro = (isLogged)
                    ?   'Selezionare il proprietario'
                    :   specificError

                global = 'Alcuni valori del proprietario non sono validi'
            }

            else if (errorString === 'ALTRI_CONDUCENTI') {
                altriConducentiErro = 'Valore non valido'
                global = 'Indicare se esiste un altro conducente'
            }
            else if (errorString === 'ETA_CONDUCENTE_PIU_GIOVANE') {
                etaConducentePiuGiovaneErro = 'Valore non valido'
                global = "Selezionare l'età del conducente più giovane"
            }
            
            else if ( errorString === 'PRIVACY' ) {
                noMotorPrivacyErro = 'Selezionare i campi obbligatori'
                global = noMotorPrivacyErro
            } 
            else {
                global = errorString
            }
            
            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,

                tipoVeicoloError: tipoVeicoloErro,
                targaError: targaErro,

                annoImmatricolazioneError: immatricolazioneErro,
                annoAcquistoError: annoAcquistoErro,
                meseImmatricolazioneError: meseImmatricolazioneErro,

                marcaError: marcaErro,
                modelloError: modelloErro,
                alimentazioneError: alimentazioneErro,
                allestimentoError: allestimentoErro,
                kwError: kwErro,
                marceError: marceErro,

                statoAssicurativoError: statoAssicurativoErro,
                tipoEreditaCuError: tipoEreditaCuErro,
                cuEreditataError: cuEreditataErro,
                tipoVeicoloEreditaCuError: tipoVeicoloEreditaCuErro,
                targaCuError: targaCuErro,

                cuAttualeError: cuAttualeErro,
                anzianitaPrimaClasseError: anzianitaPrimaClasseErro,
                compagniaAttualeError: compagniaAttualeErro,
                etaAssicurativaError: etaAssicurativaErro,
                numeroIncidentiError: numeroIncidentiErro,
                incidentiError: incidentiErro,
                haEreditatoCuError: haEreditatoCuErro,

                isSameContractorOwnerError: isSameContractorOwnerErro,
                ownerError: ownerErro,

                altriConducentiError: altriConducentiErro,
                etaConducentePiuGiovaneError: etaConducentePiuGiovaneErro,

                noMotorPrivacyError: noMotorPrivacyErro,

                globalError: global,
            })
        }
    }

    getSpecificDataForSubmit () {
        let datiVeicoloToSend = {
            tipologieVeicoloGenerica: 4, // CICLOMOTORE(4,"Ciclomotore"),

            tipoSpecificoVeicolo: this.state.tipoVeicolo ?? null,
            targa: this.state.targa ?? null,
            annoImmatricolazione: this.state.annoImmatricolazione ?? null,
            annoAcquisto: this.state.annoAcquisto ?? null,
            meseImmatricolazione: this.state.meseImmatricolazione ?? null,
            marca: this.state.marca ?? null,
            modello: this.state.modello ?? null,
            alimentazione: this.state.alimentazione ?? null,
            allestimento: this.state.allestimento ?? null,
            kw: this.state.kw ?? null,
            marce: this.state.marce ?? null,
        }
        
        let datiAssicurativiToSend = {
            dataScadenza: this.state.scadenzaPolizza ?? null,
            statoAssicurativoId: this.state.statoAssicurativo,
            altriConducenti: this.state.altriConducenti ?? null,
            etaConducentePiuGiovane: this.state.etaConducentePiuGiovane ?? null
        }

        if (this.state.statoAssicurativo === 'assicurataAMioNome') {
            datiAssicurativiToSend = {
                ...datiAssicurativiToSend,
                ...{
                    polizzaGiaAttiva: true,
                    cuAttuale: this.state.cuAttuale ?? null,
                    anzianitaPrimaClasse: this.state.anzianitaPrimaClasse ?? null,
                    compagniaAttualeId: this.state.compagniaAttuale ?? null,
                    etaAssicurativa: this.state.etaAssicurativa ?? null,
                    numeroIncidenti: this.state.numeroIncidenti ?? null,
                    incidenti: (this.state.numeroIncidenti ?? 0) ? this.state.incidenti ?? null : null,
                    haEreditatoCu: this.state.haEreditatoCu ?? null,
                }
            }
        }
        else {
            datiAssicurativiToSend = {
                ...datiAssicurativiToSend,
                ...{
                    polizzaGiaAttiva: false,
                    tipoEreditaCu: this.state.tipoEreditaCu ?? null,
                    cuEreditata: (Number(this.state.tipoEreditaCu ?? 0) > 1) ? this.state.cuEreditata ?? null : null,
                    tipoVeicoloEreditaCu: (Number(this.state.tipoEreditaCu ?? 0) > 1) ? this.state.tipoVeicoloEreditaCu ?? null : null,
                    targaCu: (Number(this.state.tipoEreditaCu ?? 0) > 1) ? this.state.targaCu ?? null : null,
                    numeroIncidenti: 0,
                }
            }
        }

        // dati sul proprietario
        if ( this.state.contractor.tipoPersona === 'fisica' ) {
            datiAssicurativiToSend = {
                ...datiAssicurativiToSend,
                ...{
                    contraenteProprietario: this.state.isSameContractorOwner,
                    proprietario: (this.isNotSameOC() === true) ? getGenericPeopleForSubmit(this.state.owner, this.state.contractor) : null
                }
            }
        }
        else {
            datiAssicurativiToSend = {
                ...datiAssicurativiToSend,
                ...{
                    contraenteProprietario: 1, // si sono la stessa persona
                    proprietario: null
                }
            }
        }

        return {
            datiVeicolo: datiVeicoloToSend,
            datiAssicurativi: datiAssicurativiToSend,

            tipoVeicolo: this.state.tipoVeicolo ?? null,
            targa: this.state.targa ?? null,
        }
    }

    saveStateAndRedux (newState : object) {
        this.setState(
            newState, () => {
                store.dispatch (
                    microcarUpdate (this.state)
                )
            }
        )
    }

    /**
     * Va sovrascritto, in modod da poter gestire il proprietario!
     * @param c il contraente della polizza
     */
    updateContractor (c: ContractorType) {
        let next = {
            contractor: c,
            isSameContractorOwner: this.state.isSameContractorOwner,
            owner: this.state.owner
        }

        if (c.tipoPersona === 'fisica') {
            next.contractor.nomeAzienda = undefined
            next.contractor.pIva = undefined
            next.contractor.ragioneSociale = undefined
        } else {
            next.contractor.sesso = undefined
            next.contractor.data_nascita = undefined
            next.contractor.stato_nascita = undefined
            next.contractor.comune_nascita = undefined
            next.contractor.professione = undefined
            next.isSameContractorOwner = 1 // si(1,"Sì, sono la stessa persona")
            next.owner = undefined
        }

        this.saveStateAndRedux( next )
    }

    // -- specifici 

    // enums --->
    private updateTipiVeicolo (val: any) {
        this.setState({
            tipiVeicolo: val
        })
    }
    private updateTipiAlimentazione (val: any) {
        this.setState({
            tipiAlimentazione: val
        })
    }
    private updateTipiMarce (val: any) {
        this.setState({
            tipiMarce: val
        })
    }
    private updateTipiStatoAssicurativo (val: any) {
        this.setState({
            tipiStatoAssicurativo: val
        })
    }

    private updateTipiFruizioneEredita (val: any) {
        this.setState({
            tipiFruizioneEredita: val
        })
    }
    private updateTipiCuEreditata (val: any) {
        this.setState({
            tipiCuEreditata: val
        })
    }
    private updateTipiCuAttuale (val: any) {
        let tmp = val

        if (val !== undefined) {
            tmp = (val as Array<BaseEnumType>).sort(
                (a: BaseEnumType, b: BaseEnumType) => (Number(a.id) > Number(b.id)) ? 1 : -1
            )
        }

        this.setState({
            tipiCuAttuale: tmp
        })
    }
    private updateTipiAnzianitaPrimaClasse (val: any) {
        this.setState({
            tipiAnzianitaPrimaClasse: val
        })
    }
    private updateTipiCompagnieAttuali (val: any) {
        this.setState({
            tipiCompagnieAttuali: val
        })
    }
    private updateTipiEtaAssicurativa (val: any) {
        this.setState({
            tipiEtaAssicurativa: val
        })
    }
    private updateTipiAnniIncidenti (val: any) {
        this.setState({
            tipiAnniIncidenti: val
        })
    }
    private updateTipiResponsabilitaIncidenti (val: any) {
        this.setState({
            tipiResponsabilitaIncidenti: val
        })
    }
    private updateTipiVeicoloEretiaCu (val: any) {
        this.setState({
            tipiVeicoloEretiaCu: val
        })
    }
    private updateTipiRelazioniPersone (val: any) {
        this.setState({
            tipiRelazioniPersone: val
        })
    }
    // <--- enums

    private updateTipoVeicolo (val: string | undefined) {
        let next = {
            tipoVeicolo: val,
            tipoVeicoloError: undefined
        }

        if (val !== this.state.tipoVeicolo) {
            next = {
                ...next,
                ...{
                    marce:  undefined,
                    marceError: undefined
                }
            }
        }

        this.saveStateAndRedux( next )
    }
    private updateTarga (val: string | undefined) {
        this.saveStateAndRedux({
            targa: val,
            targaError: undefined
        })
    }

    // NOTA: implementazione inserimento manuale di tutti i valori 
    // -> i valori non possono essere legati tra loro 
    // -> non li pulisco al change !!!!

    private updateAnnoImmatricolazione (val: number | undefined) {
        let next = {
            annoImmatricolazione: val,
            annoImmatricolazioneError: undefined
        }

        if (val !== undefined && Number(val) > Number(this.state.annoAcquisto)) {
            const currentMonth = Number( moment().month() )

            let month = this.state.meseImmatricolazione

            if (month !== undefined && Number(this.state.meseImmatricolazione) < currentMonth) {
                month = currentMonth
            }

            next = {
                ...next,
                ...{
                    annoAcquisto: val,
                    annoAcquistoError: undefined,
                    meseImmatricolazione: month,
                    meseImmatricolazioneError: undefined,
                }
            }
        }

        this.saveStateAndRedux( next )
    }
    private updateMeseImmatricolazione (val: number | undefined) {
        this.saveStateAndRedux({
            meseImmatricolazione: val,
            meseImmatricolazioneError: undefined
        })
    }
    private updateAnnoAcquisto (val: number | undefined) {
        let next = {
            annoAcquisto: val,
            annoAcquistoError: undefined
        }

        this.saveStateAndRedux( next )
    }


    private updateMarca (val: string | undefined) {
        this.saveStateAndRedux ({
            marca: val,
            marcaError: undefined
        })
    }
    private updateModello (val: string | undefined) {
        this.saveStateAndRedux ({
            modello: val,
            modelloError: undefined
        })
    }
    private updateAlimentazione (val: string | undefined) {
        this.saveStateAndRedux ({
            alimentazione: val,
            alimentazioneError: undefined
        })
    }
    private updateAllestimento (val: string | undefined) {
        this.saveStateAndRedux ({
            allestimento: val,
            allestimentoError: undefined
        })
    }
    private updateKw (val: number | undefined) {
        this.saveStateAndRedux ({
            kw: val,
            kwError: undefined
        })
    }
    private updateMarce (val: number | undefined) {
        this.saveStateAndRedux ({
            marce: val,
            marceError: undefined
        })
    }

    private updateStatoAssicurativo (val: string | undefined ) {
        let next = {
            statoAssicurativo: val,
            statoAssicurativoError: undefined
        }

        if (val === undefined) {
            // devo annullare tutto
            next = {
                ...next,
                ...{
                    tipoEreditaCu: undefined,
                    tipoVeicoloEreditaCu: undefined,
                    targaCu: undefined,
                    cuEreditata: undefined,
                    cuAttuale: undefined,
                    anzianitaPrimaClasse: undefined,
                    compagniaAttuale: undefined,
                    etaAssicurativa: undefined,
                    haEreditatoCu: undefined,
                    numeroIncidenti: undefined,
                    incidenti: undefined,

                    tipoEreditaCuError: undefined,
                    tipoVeicoloEreditaCuError: undefined,
                    targaCuError: undefined,
                    cuEreditataError: undefined,
                    cuAttualeError: undefined,
                    anzianitaPrimaClasseError: undefined,
                    compagniaAttualeError: undefined,
                    etaAssicurativaError: undefined,
                    haEreditatoCuError: undefined,
                    numeroIncidentiError: undefined,
                    incidentiError: undefined,

                    polizzaAttiva: undefined,
                }
            }
        }
        else if (val === 'assicurataAMioNome') {
            // annullo valori "Nuovo || Usato"
            next = {
                ...next,
                ...{
                    tipoEreditaCu: undefined,
                    tipoVeicoloEreditaCu: undefined,
                    targaCu: undefined,
                    cuEreditata: undefined,

                    tipoEreditaCuError: undefined,
                    tipoVeicoloEreditaCuError: undefined,
                    targaCuError: undefined,
                    cuEreditataError: undefined,

                    polizzaAttiva: true, // il veciolo è "già assicurato a mio nome"!
                }
            }
        }
        else if (
            val === 'aMioNomePrimaVoltaNuovo' ||
            val === 'aMioNomePrimaVoltaUsato'
        ) {
            // annullo valori "a mio nome"
            next = {
                ...next,
                ...{
                    cuAttuale: undefined,
                    anzianitaPrimaClasse: undefined,
                    compagniaAttuale: undefined,
                    etaAssicurativa: undefined,
                    haEreditatoCu: undefined,
                    numeroIncidenti: undefined,
                    incidenti: undefined,

                    cuAttualeError: undefined,
                    anzianitaPrimaClasseError: undefined,
                    compagniaAttualeError: undefined,
                    etaAssicurativaError: undefined,
                    haEreditatoCuError: undefined,
                    numeroIncidentiError: undefined,
                    incidentiError: undefined,

                    polizzaAttiva: false, // il veciolo NON è "già assicurato a mio nome"!
                }
            }
        }

        this.saveStateAndRedux( next )
    }

    private updateTipoEreditaCu (val: number | undefined ) {
        let next = {
            tipoEreditaCu: val,
            tipoEreditaCuError: undefined
        }

        if (val === undefined || Number(val) === 1) {
            // caso:  no(1,"No"),
            next = {
                ...next,
                ...{
                    tipoVeicoloEreditaCu: undefined,
                    targaCu: undefined,
                    cuEreditata: undefined,
                    tipoVeicoloEreditaCuError: undefined,
                    targaCuError: undefined,
                    cuEreditataError: undefined,
                }
            }
        }

        this.saveStateAndRedux(next)
    }
    private updateTipoVeicoloEreditaCu (val: number | undefined) {
        this.saveStateAndRedux({
            tipoVeicoloEreditaCu: val,
            tipoVeicoloEreditaCuError: undefined,
            targaCu: undefined,
            targaCuError: undefined
        })
    }
    private updateTargaCu (val: string | undefined ) {
        this.saveStateAndRedux({
            targaCu: val,
            targaCuError: undefined
        })
    }
    private updateCuEreditata (val: number | undefined ) {
        this.saveStateAndRedux({
            cuEreditata: val,
            cuEreditataError: undefined
        })
    }
    private updateCuAttuale (val: number | undefined ) {
        let next = {
            cuAttuale: val,
            cuAttualeError: undefined
        }

        if (val === undefined || Number(val) !== -1) {
            // c1DaOltreUnAnno(-1, "1, da almeno un anno" ),
            next = {
                ...next,
                ...{
                    anzianitaPrimaClasse: undefined,
                    anzianitaPrimaClasseError: undefined
                }
            }
        }

        this.saveStateAndRedux(next)
    }
    private updateAnzianitaPrimaClasse (val: number | undefined ) {
        this.saveStateAndRedux({
            anzianitaPrimaClasse: val,
            anzianitaPrimaClasseError: undefined
        })
    }
    private updateCompagniaAttuale (val: number | undefined ) {
        this.saveStateAndRedux({
            compagniaAttuale: val,
            compagniaAttualeError: undefined
        })
    }
    private updateEtaAssicurativa (val: number | undefined ) {
        this.saveStateAndRedux({
            etaAssicurativa: val,
            etaAssicurativaError: undefined
        })
    }
    private updateHaEreditatoCu (val: boolean | undefined ) {
        this.saveStateAndRedux({
            haEreditatoCu: val,
            haEreditatoCuError: undefined
        })
    }
    private updateNumeroIncidenti (val: number | undefined) {
        let next = {
            numeroIncidenti: val,
            numeroIncidentiError: undefined,
            altriSinistri: Number(val ?? 0) > 0, // se ho 0 incidenti.. 
            altriSinistriError: undefined
        }

        if (val === undefined || val === 0) {
            next = {
                ...next,
                ...{
                    incidenti: [],
                    incidentiError: []
                }
            }
        }
        else if (
            this.state.incidenti?.length !== undefined &&
            val < this.state.incidenti.length
        ) {
            // ese : ho settato 1 incidente, ma this.state.incidenti.length = 2 
            // --> devo togliere 1 incidente a partire da numero di incidenti
            // ps: c'è il rischio che in detterminati momenti sia "readonly" (pesco dallo stato!)
            let nextIncidenti = [...this.state.incidenti]
            let nextIncidentiError = [...this.state.incidentiError]
            
            const toRemove = Number( val )

            if (nextIncidenti.length > toRemove) {
                nextIncidenti.splice( toRemove )
            }
            if (nextIncidentiError.length > toRemove) {
                nextIncidentiError.splice( toRemove )
            }

            next = {
                ...next,
                ...{
                    incidenti: nextIncidenti,
                    incidentiError: nextIncidentiError
                }
            }
        }

        this.saveStateAndRedux (next)
    }
    private updateIncidenti ( incidenti: AccidentListType, errori: AccidentErrorList) { // BaseAccidentProps
        this.saveStateAndRedux({
            incidenti: incidenti,
            incidentiError: errori
        })
    }

    private updateIsSameContractorOwner (val: number | undefined) {
        let next = {
            isSameContractorOwner: val,
            isSameContractorOwnerError: undefined
        }

        if (val === undefined || 1 === Number(val)) {
            next = {
                ...next,
                ...{
                    owner: undefined,
                    ownerError: undefined
                }
            }
        }

        this.saveStateAndRedux( next )
    }

    private updateOwner (val : FisicaType | undefined) {
        // forzo l'assegnamento
        if (
            val !== undefined && 
            this.state.statoAssicurativo === 'assicurataAMioNome' &&
            this.isNotSameOC() === true
        ) {
            val.email = this.state.contractor.email
            val.cellulare = this.state.contractor.cellulare
        }

        this.saveStateAndRedux({
            owner: val,
            ownerError: undefined
        })
    }

    private updateAltriConducenti (val: boolean | undefined) {
        let next = {
            altriConducenti: val,
            altriConducentiError: undefined
        }

        if (val === undefined || val === false) {
            next = {
                ...next,
                ...{
                    etaConducentePiuGiovane: undefined,
                    etaConducentePiuGiovaneError: undefined
                }
            }
        }

        this.saveStateAndRedux( next )
    }
    private updateEtaConducentePiuGiovane (val: number | undefined) {
        this.saveStateAndRedux({
            etaConducentePiuGiovane: val,
            etaConducentePiuGiovaneError: undefined
        })
    }

    private getStep2ForValidation () {
        return {
            tipoSpecificoVeicolo: this.state.tipoVeicolo ?? null,
            targa: this.state.targa ?? null,
            annoImmatricolazione: this.state.annoImmatricolazione ?? null,
            annoAcquisto: this.state.annoAcquisto ?? null,
            meseImmatricolazione: this.state.meseImmatricolazione ?? null,
            marca: this.state.marca ?? null,
            modello: this.state.modello ?? null,
            alimentazione: this.state.alimentazione ?? null,
            allestimento: this.state.allestimento ?? null,
            kw: this.state.kw ?? null,
            marce: this.state.marce ?? null,
        }
    }

    private async step2Validation () {
        let error = undefined

        if (this.state.tipoVeicolo === undefined) {
            error = 'TIPOVEICOLO'
        }
        else if (
            this.state.targa === undefined || 
            (this.state.tipoVeicolo !== 'quadriciclo' && !isValid(this.state.targa?.toUpperCase(), PATTERN_TARGA_50CC)) ||
            (this.state.tipoVeicolo === 'quadriciclo' && !isValidTarga(this.state.targa?.toUpperCase(), 2))
        ) {
            error = 'TARGA'
        }

        else if (isEmpty(this.state.annoImmatricolazione?.toString())) {
            error = "ANNO_IMMATRICOLAZIONE"
        }
        
        else if (isEmpty(this.state.meseImmatricolazione?.toString())) {
            error = "MESE_IMMATRICOLAZIONE"
        }
        else if (isEmpty(this.state.annoAcquisto?.toString())) {
            error = "ANNO_ACQUISTO"
        }

        else if (isEmpty(this.state.marca)) {
            error = 'MARCA'
        }
        else if (isEmpty(this.state.modello)) {
            error = 'MODELLO'
        }
        else if (this.state.allestimento === undefined) {
            error = 'ALLESTIMENTO'
        }
        else if (isEmpty(this.state.alimentazione)) {
            error = 'ALIMENTAZIONE'
        }
        else if (this.state.kw === undefined || Number(this.state.kw) <= 0) {
            error = 'KW'
        }
        else if (this.state.marce === undefined) {
            error = 'MARCE'
        }

        else {
            await authFetch (
                STEP_2_VALIDATION_URL,
                {
                    method: "post",
                    body: JSON.stringify({
                        specificData: this.getStep2ForValidation(),
                        
                    })
                },
                this.manageExpiredSessions,
            ).then ( jsonObj => {
                if (jsonObj.status > 200) {
                    error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
                }
            }).catch( error => {
                error = CONNECTION_ERROR
            })
        }

        this.printError(error)

        return error
    }

    private getStep3ForValidation () {
        let daNext = {
            dataScadenza: this.state.scadenzaPolizza ?? null,
            statoAssicurativoId: this.state.statoAssicurativo,
            contraenteProprietario: this.state.isSameContractorOwner ?? null,
            proprietario: (this.isNotSameOC() === true) ? getGenericPeopleForSubmit(this.state.owner, this.state.contractor) : null,
            altriConducenti: this.state.altriConducenti ?? null,
            etaConducentePiuGiovane: this.state.etaConducentePiuGiovane ?? null
        }

        if (this.state.statoAssicurativo === 'assicurataAMioNome') {
            daNext = {
                ...daNext,
                ...{
                    polizzaGiaAttiva: true,
                    cuAttuale: this.state.cuAttuale ?? null,
                    anzianitaPrimaClasse: this.state.anzianitaPrimaClasse ?? null,
                    compagniaAttualeId: this.state.compagniaAttuale ?? null,
                    etaAssicurativa: this.state.etaAssicurativa ?? null,
                    numeroIncidenti: this.state.numeroIncidenti ?? null,
                    incidenti: (this.state.numeroIncidenti ?? 0) ? this.state.incidenti ?? null : null,
                    haEreditatoCu: this.state.haEreditatoCu ?? null,
                }
            }
        }
        else {
            daNext = {
                ...daNext,
                ...{
                    polizzaGiaAttiva: false,
                    tipoEreditaCu: this.state.tipoEreditaCu ?? null,
                    cuEreditata: (Number(this.state.tipoEreditaCu ?? 0) > 1) ? this.state.cuEreditata ?? null : null,
                    tipoVeicoloEreditaCu: (Number(this.state.tipoEreditaCu ?? 0) > 1) ? this.state.tipoVeicoloEreditaCu ?? null : null,
                    targaCu: (Number(this.state.tipoEreditaCu ?? 0) > 1) ? this.state.targaCu ?? null : null,
                    numeroIncidenti: 0,
                }
            }
        }

        const next = {
            datiAssicurativi: daNext,
            privacy: getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user ),
            isLogged: this.state.expiredSessionError === false ? this.state.user !== undefined : false
        }

        return next
    }

    private isNotSameOC() : boolean {
        return !isNaN(Number(this.state.isSameContractorOwner)) && Number(this.state.isSameContractorOwner) !== 1
    }

    private async step3Validation () {
        const isLogged = (this.state.user !== undefined)

        let error = undefined

        if (this.state.statoAssicurativo === undefined) {
            error = "STATO_ASSICURATIVO"
        }
        else if (
            isNotValidScadenzaPolizza(this.state.scadenzaPolizza)
        ) {
            error = 'SCADENZA_POLIZZA'
        }
        else if (this.state.statoAssicurativo === 'assicurataAMioNome') {
            if (this.state.cuAttuale === undefined) {
                error = "CU_ATTUALE"
            }
            else if (
                this.state.cuAttuale !== undefined && Number(this.state.cuAttuale) === -1 &&
                this.state.anzianitaPrimaClasse === undefined
            ) {
                error = "ANZIANITA_PRIMA_CLASSE"
            }
            else if (this.state.compagniaAttuale === undefined) {
                error = "COMPAGNIA_ATTUALE"
            }
            else if (this.state.etaAssicurativa === undefined) {
                error = "ETA_ASSICURATIVA"
            }
            else if (this.state.numeroIncidenti === undefined) {
                error = "NUMERO_INCIDENTI"
            }
            else if (
                (this.state.numeroIncidenti !== undefined && Number(this.state.numeroIncidenti) > 0) &&
                (
                    this.state.incidenti === undefined ||
                    this.state.numeroIncidenti !== this.state.incidenti.length ||
                    this.state.incidenti.findIndex( (acc: AccidentType) => isEmpty(acc.anno) ) >= 0 ||
                    this.state.incidenti.findIndex( (acc: AccidentType) => isEmpty(acc.responsabilita) ) >= 0
                )
            ) {
                // segnalo l'errore -- i dettagli sono gestiti nella printError!
                error = "DETTAGLIO_INCIDENTI"
            }
            else if (this.state.haEreditatoCu === undefined) {
                error = "HA_EREDITATO_CU"
            }
        }
        else if (this.state.statoAssicurativo !== 'assicurataAMioNome') {
            if (this.state.tipoEreditaCu === undefined) {
                error = "TIPO_EREDITA_CU"
            }
            else if (
                this.state.tipoEreditaCu !== undefined &&
                Number(this.state.tipoEreditaCu) > 1 // NO
            ) {
                if (this.state.cuEreditata === undefined ) {
                    error = 'CU_EREDITATA'
                }
                else if (this.state.tipoVeicoloEreditaCu === undefined) {
                    error = "TIPO_VEICOLO_ERETIA"
                }
                else if (!isValidTarga( this.state.targaCu?.toUpperCase(), this.state.tipoVeicoloEreditaCu)) {
                    error = 'TARGA_CU'
                }
            }
        }   
        
        if (error === undefined && this.state.isSameContractorOwner === undefined) {
            error = 'CONTRAENTE_PROPRIETARIO'
        }
        else if (
            error === undefined && 
            this.isNotSameOC() && 
            (
                this.state.owner === undefined ||
                getGenericPeopleError(this.state.owner, 'PROPRIETARIO', isLogged) !== undefined
            )
        ) {
            error = 'PROPRIETARIO'
        }

        if (error === undefined && this.state.altriConducenti === undefined) {
            error = "ALTRI_CONDUCENTI"
        }
        else if (
            error === undefined && 
            this.state.altriConducenti === true && 
            isEmpty(this.state.etaConducentePiuGiovane?.toString())
        ) {
            error = 'ETA_CONDUCENTE_PIU_GIOVANE'
        }

        if (error === undefined && !isValidPrivacy(this.state.noMotorPrivacy, isLogged)) {
            error = 'PRIVACY'
        }
        else if (error === undefined) {
            await authFetch (
                STEP_3_VALIDATION_URL,
                {
                    method: "post",
                    body: JSON.stringify(
                        this.getStep3ForValidation()
                    )
                },
                this.manageExpiredSessions,
            ).then ( jsonObj => {
                if (jsonObj.status > 200) {
                    error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
                }
            }).catch( error => {
                error = CONNECTION_ERROR
            })
        }

        this.printError(error)

        return error
    }

    private isValidTargaVeicolo () {
        return isValid(this.state.targa?.toUpperCase(), PATTERN_TARGA_50CC)
    }

    
    private isValidAnnoImmatricolazione (val : number | undefined) {
        if (!isEmpty(val?.toString()) && this.state.annoAcquisto !== undefined) {
            return Number(val) <= Number(this.state.annoAcquisto)
        }
        return true
    }
    private isValidAnnoAcquisto (val : number | undefined) {
        if (!isEmpty(val?.toString()) && this.state.annoImmatricolazione !== undefined) {
            return Number(val) >= Number(this.state.annoImmatricolazione)
        }
        return true
    }
    private isValidMeseAcquisto (val : number | undefined) {        
        if (!isEmpty(val?.toString()) && this.state.annoImmatricolazione !== undefined) {
            const currentYear = Number( moment().year() )
            const currentMonth = Number( moment().month() )

            // se anno corrente il mese di aquisto deve essere nel passato
            if (currentYear === Number(this.state.annoImmatricolazione)) {
                return Number(val) >= currentMonth
            }
        }
        return true
    }
      
}

const mapState = (state: any) => {
  return {
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,

    tipoVeicolo: state.tipoVeicolo,
    targa: state.targa,
    annoImmatricolazione: state.annoImmatricolazione,
    annoAcquisto: state.annoAcquisto,
    meseImmatricolazione: state.meseImmatricolazione,
    marca: state.marca,
    modello: state.modello,
    alimentazione: state.alimentazione,
    allestimento: state.allestimento,
    kw: state.kw,
    marce: state.marce,

    statoAssicurativo: state.statoAssicurativo,
    tipoEreditaCu: state.tipoEreditaCu,
    tipoVeicoloEreditaCu: state.tipoVeicoloEreditaCu,
    targaCu: state.targaCu,
    cuEreditata: state.cuEreditata,
    cuAttuale: state.cuAttuale,
    anzianitaPrimaClasse: state.anzianitaPrimaClasse,
    compagniaAttuale: state.compagniaAttuale,
    etaAssicurativa: state.etaAssicurativa,
    haEreditatoCu: state.haEreditatoCu,

    numeroIncidenti: state.numeroIncidenti,
    incidenti: state.incidenti,

    isSameContractorOwner: state.isSameContractorOwner,
    owner: state.owner,

    altriConducenti: state.altriConducenti,
    etaConducentePiuGiovane: state.etaConducentePiuGiovane,

    actualPage: state.actualPage,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user
  }
}

export default connect(mapState) (MicroCarPage)